import { Plugin } from "./plugin";
import { WorkgroupInformationModel } from "./workgroup-information.model";

export class User {
  id!: number;
  username!: string;
  firstname!: string;
  prefix?: string;
  lastname!: string;
  accesstoken?: string;
  idtoken?: string;
  /**
   * According to the Gaurds this is a string[] containing the named values of Roles
   */
  role: any;
  fullName!: string;
  email!: string;
  phoneNumber!: string;
  isCustomer!: boolean;
  isOrganisationAdmin!: boolean;
  isWhitelabelAdmin!: boolean;
  isSystemAdmin!: boolean;
  subscriptionLevel!: string;
  organisationGuid!: string;
  organisation!: string;
  /** The User Guid!!! */
  sub!: string;
  cscProviderName!: string;
  signatureProvider!: string;
  language!: string;

  /**
   * Enabled Plugins set by organisation
   * -Frontend retrieved property
   */
  enabledOrganisationPlugins: Plugin[] = [];
  /**
   * Whether a Microsoft Plugin is enabled
   * -See enabledOrganisationPlugins
   * -Frontend retrieved property
   */
  aMsPluginIsEnabled: boolean = false;

}

export class UserSearchResult {
  constructor(
    public firstname: string,
    public prefix: string,
    public lastname: string,
    public email: string,
    public mobile: string) { }
}

export class FindUserModel {
  constructor(
    public voornaam: string,
    public tussenvoegsels: string,
    public achternaam: string,
    public email: string,
    public telefoon: string,
    public id?: string) { }
}

export interface IUserResponse {
  total: number;
  results: UserSearchResult[];
}

export interface UserModel {
  Email: string;
  Lastname: string;
  Prefix: string | null | undefined;
  Firstname: string;
  PhoneNumber: string;
}

